// Tells screen reader users about something that changed without moving focus, e.g. "Copied". One polite live
// region for the whole page, created on first use.
let region: HTMLElement | null = null;

export function announce(message: string): void {
    if (!region) {
        region = document.createElement('div');
        region.className = 'visually-hidden';
        region.setAttribute('role', 'status');
        document.body.appendChild(region);
    }
    const target = region;
    // Cleared first, so the same message twice in a row is still announced.
    target.textContent = '';
    setTimeout(() => target.textContent = message, 100);
}
